import React, { Component, Fragment } from 'react';
import { Form, Button, Icon, message, Modal, Tag } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Coins from '../../components/Coins';
import CreatePair from '../CreatePair';
import { putExchange, getPairs, storePairs, updatePair } from '../../common/fetch';
import { SetupAction, PairAction } from '../../actions';
import RemoveConfirmation from './Confirmation';
import { CofirmationWrapper, FormWrapper } from './style';
import { DashLinksToolTip } from '../Hosting/Utils';

const { Item } = Form;

class Pairs extends Component {
	state = {
		isOpen: false,
		currency: [],
		coins: [],
		isNew: false,
		isEdit: false,
		editData: {},
		selectedPairs: ['btc-usdt', 'eth-usdt', 'xht-usdt'],
		display_content: '0',
		button_top: '-40px',
		step: 'step1',
		currentStep: 'step1',
		isRemovePair: false,
		removePair: [],
	};

	componentDidMount() {
		this.configurePair();
		this.updateCoins();
	}

	componentDidUpdate(prevProps, prevState) {
		if ((JSON.stringify(prevProps.state) !== JSON.stringify(this.props.state)) ||
			(JSON.stringify(prevProps.exchange) !== JSON.stringify(this.props.exchange))) {
			this.updateCoins();
			this.configurePair();
		}
		if (this.state.display_content === '0') {
			setTimeout(() => {
				this.setState({ button_top: "0px" });
			}, 1300);
			setTimeout(() => {
				this.setState({ display_content: "1" });
			}, 1500);
		}
	}

	getTradingPairs = async () => {
		const { pairAction } = this.props;
		try {
			const res = await getPairs();
			if (res.data && res.data.data) {
				pairAction.setPair(res.data.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	updateCoins = () => {
		if (this.props.state
			&& this.props.state.pairs
			&& this.props.state.pairs.length) {
			this.setState({
				selectedPairs: this.props.state.pairs.map(data => {
					if (typeof data === 'string') {
						return data;
					} else {
						return data.symbol ? data.symbol : data.name;
					}
				})
			});
		}
	};

	configurePair = () => {
		const { coins = [] } = this.props.state;
		let coinList = coins.map(data => typeof data === 'string' ? data : data.symbol);
		const selectedPairs = this.state.selectedPairs.filter(pair => {
			let [pair_base = '', pair_2 = ''] = pair.split('-');
			return coinList.includes(pair_base) && coinList.includes(pair_2);
		});
		this.setState({ selectedPairs });
	};

	openModal = (symbol) => {
		this.setState({
			isOpen: true,
			currency: symbol,
			isNew: symbol.length === 0,
		});
	};

	closeModal = () => {
		this.setState({ isOpen: false, isEdit: false, editData: {}, isRemovePair:false });
	};

	handleEdit = (formData) => {
		this.setState({
			isEdit: true,
			editData: formData
		});
	};

	removePair = (symbols) => {
		const { state, actions } = this.props;
		let selectedPairs = this.state.selectedPairs.filter(pair => pair !== `${symbols[0]}-${symbols[1]}`);
		const newData = { ...state, pairs: selectedPairs };
		actions.updateBiz(newData);
		this.setState({ selectedPairs, isRemovePair:false });
	};

	handleSubmit = async (e) => {
		e.preventDefault();
		const { state } = this.props;
		if (this.state.selectedPairs.length === 0) {
			message.warn('You need to set at least one market.');
			return;
		}
		try {
			const exchangeBody = {
				id: state.id,
				info: {
					// biz: {
					// 	PAIRS: state.PAIRS,
					// },
					is_temp: state.is_temp,
				},
				pairs: this.state.selectedPairs
			};
			// delete exchangeBody.info.biz.id;
			const data = { ...state, pairs: this.state.selectedPairs };
			await putExchange(exchangeBody);
			this.props.actions.updateBiz(data);
			this.props.onOk();
		} catch (error) {
			console.error(error);
			message.error('Failed to update setup configs');
		}
	};

	addPairs = () => {
		this.closeModal();
	};

	handleConfirm = async (formData, isEdit = false) => {
		const { selectedPairs } = this.state;
		if (isEdit) {
			if (!formData.name) {
				formData.name = `${formData.pair_base}-${formData.pair_2}`;
			}
			if (!formData.estimated_price) {
				formData.estimated_price = 1;
			}
			try {
				await updatePair(formData);
				await this.getTradingPairs();
			} catch (error) {
				if (error && error.data) {
					message.error(error.data.message)
				}
			}
			// if (selectedPairs.includes(`${formData.pair_base}-${formData.pair_2}`)) {
			// 	message.warning('Pairs already exists');
			// } else {
			// 	let tempPairs = selectedPairs.filter((data) => data !== `${baseDataEdit.pair_base}-${baseDataEdit.pair_2}`);
			// 	this.setState({ selectedPairs: tempPairs }, () => {
			// 		formData.name = `${formData.pair_base}-${formData.pair_2}`;
			// 		formData.code = `${formData.pair_base}-${formData.pair_2}`;
			// 		this.handleConfirm(formData);
			// 	});
			// }
		} else {
			if (!formData.name) {
				formData.name = `${formData.pair_base}-${formData.pair_2}`;
			}
			if (!formData.estimated_price) {
				formData.estimated_price = 1;
			}
			let tempPairs = [...selectedPairs];
			if (tempPairs.includes(formData.name)) {
				message.warning('Markets already exists');
			} else if (!this.props.allPairs.filter(data => data.name === formData.name).length) {
				try {
					const res = await storePairs(formData);
					tempPairs = [...tempPairs, `${formData.pair_base}-${formData.pair_2}`];
					this.props.pairAction.addPair(res.data)
				} catch (error) {
					if (error && error.data) {
						message.error(error.data.message)
					}
				}
				message.success('Markets created successfully');
			} else {
				tempPairs = [...tempPairs, `${formData.pair_base}-${formData.pair_2}`];
			}
			this.setState({ selectedPairs: tempPairs });
		}
	};

	renderPairs = () => {
		const iconStyle = {
			fontSize: '22px',
			color: '#3A4FFF',
		};
		return this.state.selectedPairs.map((item, index) => {
			let tempData = this.props.allPairs.filter(data => data.code === item)[0] || {};
			let [pair_base = '', pair_2 = ''] = item ? item.split('-') : '-';
			return (
				<div key={index} className="coin-list">
					<div className="coin x-mark">
						<Coins type={pair_base} small={true} />
					</div>
					<div className="coin">
						<Coins type={pair_2} small={true} />
					</div>
					<div className="icons">
						{tempData.verified
							? null
							: <Fragment>
								<Icon
									type="setting"
									style={iconStyle}
									onClick={() => {
										this.handleEdit(tempData);
									}}
								/>
								<span
									className="rm-left"
									onClick={() => {
										this.handleEdit(tempData);
									}}
								>
									Configure
								</span>
							</Fragment>
						}
						<span className="divide">|</span>
						<Icon
							type="minus-circle"
							style={iconStyle}
							onClick={() => {
								this.setState({ isRemovePair: true, removePair: [pair_base, pair_2] });
							}}
						/>
						<span
							className="rm-left"
							onClick={() => {
								this.setState({ isRemovePair: true, removePair: [pair_base, pair_2] });
							}}
						>
							Remove
						</span>
						{tempData.verified
							? null
							:
							<div className='d-flex'>
								<span className='divide'>|</span>
								<Tag className="new-tag">New</Tag>
							</div>
						}
					</div>
				</div>
			);
		});
	};

	updateCurrentStep = (currentStep) => {
		this.setState({ currentStep });
	}

	render() {
		const { isOpen, isEdit, editData, selectedPairs, button_top, step, currentStep, isRemovePair, removePair } = this.state;
		const selectedPairData = this.props.allPairs.filter((pair) => selectedPairs.includes(pair.name));
		return (
			<FormWrapper style={{ paddingTop: '24px' }}>
				<Form onSubmit={this.handleSubmit} className="pair-form">
					<Item className="last">
						<h3 className="form-label">Default Market</h3>
						<p>
							Below are preconfigured coins. Click configure to change
							deposit and withdrawal limits
						</p>
						<div className="coin-spacing">
							{this.renderPairs()}
						</div>
						<div className="new-asset d-flex">
							{/* <h3 className="form-label">Add Trading Pair</h3> */}
							<p className="add-asset" onClick={() => this.openModal([])}>
								<Icon type="plus-circle" style={{ fontSize: '33px' }} />
								<span>Add Market</span>
							</p>
							<div className='steps-dash-link'>
								<DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=AVAqJMR6ViE&t=218s'}/>
							</div>
						</div>
					</Item>
					<div className='smooth-drop'>
						<div className='animation-bounce'>
							<div className='align-center'>
								<div className='details-container' style={{ opacity: this.state.display_content }}>
									<div className='info-icon'>i</div>
									<div>Note: <span>All details can be changed at a later date</span></div>
								</div>
							</div>
							<Button
								block
								type="primary"
								htmlType="submit"
								style={{ top: button_top }}
								disabled={selectedPairs.length === 0}
							>
								Next
							</Button>
						</div>
					</div>
				</Form>
				<Modal
					visible={isOpen || isEdit || isRemovePair}
					footer={null}
					onCancel={this.closeModal}
					width={'560px'}
				>
					{isOpen || isEdit ? (
						<CreatePair
							isEdit={isEdit}
							// step={'mini-step'}
							step={step}
							currentStep={currentStep}
							updateCurrentStep={this.updateCurrentStep}
							selectedPairs={selectedPairData}
							previewData={editData}
							isExchangeWizard={true}
							handleConfirm={this.handleConfirm}
							onClose={this.closeModal}
							moveToStep={this.props.moveToStep}
						/>
					) :
						<CofirmationWrapper>
							<RemoveConfirmation
								onCancel={this.closeModal}
								onHandleRemoveMarket={this.removePair}
								removePair={removePair}
								isRemovePair={isRemovePair}
								removeContent={"Markets"}
							/>
						</CofirmationWrapper>
					}
				</Modal>
			</FormWrapper>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		state: state.setup.biz,
		exchange: state.exchange[0] || {},
		allPairs: state.pair || []
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(SetupAction, dispatch),
	pairAction: bindActionCreators(PairAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Pairs);
